export default __webpack_public_path__ + "static/media/av9.9d9767bb.jpg";